import { gql } from "@apollo/client";

export default gql`
	mutation ($vendor: String!, $receipt: String!) {
		url: createVendorComplaintTicket(vendor: $vendor, receipt: $receipt)
	}
`;
